<div class="error-content-container">
  <dxo-icon class="primary-icon" icon="warning" color="yellow" [fontSize]="44"></dxo-icon>
  <h1 class="bold heading-md">Page not found: 404</h1>
  <h3 class="heading-sm">Sorry, we can't find that page for you.</h3>
  <hr />
  <p class="info">
    The page you're looking for is no longer available. Please call us at
    <a href="tel:{{ contactPhone }}">{{ contactPhone }}</a> if you have questions.
  </p>
  <dxo-button (click)="goToHome()">Return to home <dxo-icon icon="external-link"></dxo-icon></dxo-button>
</div>